import {Component, OnDestroy, NgZone, OnInit} from '@angular/core';
import {GLOBAL} from '../../shared/global';
import {UserNameService} from '../../shared/user-name.service';
import {LinkHelper, LINK, LinkAuth} from '../../shared/router/linkhelper';
import {BookingHeaderService} from '../../booking-management/booking-header/booking-header.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MessagingService } from '../../api/messaging.service';
import { NotificationServiceBus } from '../../notification/notification.service';
import {Administrator, BookingOfficer, Interpreter, User} from '../../shared/model/user.entity';
import { AuthGuard } from '../../auth/auth.guard';
import { SubOrganisationFilterService } from '../../shared/sub-organisation-filter/sub-organisation-filter.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnDestroy, OnInit {
  linkName = LINK;
  private sub: any;
  private messageSub: any;
  userIsActive = false;
  fullName = '';
  unreadMessageThreads = 0;
  interpreterID;
  route: string;
  href;
  private pollingSub: any;
  public threadPage = 1;
  public searchInterpreterParam = '';
  public draftMessage: any;

  get currentUser() {
    return GLOBAL.currentUser;
  }

  constructor(public notificationServiceBus: NotificationServiceBus,
      private bookingHeaderService: BookingHeaderService, public ngZone: NgZone,
      private messageService: MessagingService, location: Location, private router: Router,
      public userNameService: UserNameService, private linkAuth: LinkAuth, public subOrganisationFilter: SubOrganisationFilterService) {
     this.route = location.path();
  }
  ngOnInit () {
      this.sub = this.userNameService.loggedInUser$.subscribe(
        u => {
          this.fullName = u.first_name + ' ' + u.last_name;
          this.userIsActive = GLOBAL.currentUser.verified && (GLOBAL.currentUser.disabled === false);

        });
        this.fullName = Boolean(GLOBAL.currentUser) && Boolean(GLOBAL.currentUser.first_name)
            && Boolean(GLOBAL.currentUser.first_name.length > 0 ) ?
            GLOBAL.currentUser.first_name + ' '  + GLOBAL.currentUser.last_name :
      '';
        this.userIsActive = Boolean(GLOBAL.currentUser && this.fullName && this.fullName.length > 0
        && this.fullName === GLOBAL.currentUser.first_name + ' '  + GLOBAL.currentUser.last_name);
    this.messageSub = this.messageService.messageThreadCount.subscribe((canUpdate: string) => {
      if (canUpdate === 'updateCount') {
        this.getAllMessagesThreads();
      }
    });
    this.ngZone.runOutsideAngular(() => {
      if (this.isCurrentUserAdminOrBookingOfficer()) {
        this.getAllMessagesThreads();
        this.startGetAllMessagesThreads();
      }
    });
  }

  getPicturePath() {
    return GLOBAL.currentUser.photo_url;
  }

   ngOnDestroy() {
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }
    if (this.messageSub) {
      this.messageSub.unsubscribe();
    }
    return this.sub && this.sub.unsubscribe();
  }

  isActiveLink(linkName) {
    return LinkHelper.activeLink === linkName;
  }

  setActiveLink(linkName) {
    LinkHelper.activeLink = linkName;
  }

  canShowLink(linkName) {
    return this.linkAuth.canShowLink(linkName);
  }

  refreshBooking() {
    this.bookingHeaderService.notifyOther({option: 'refreshBooking'});
  }
  getActiveUserId() {
    return GLOBAL.currentUser.id;
  }

  isCurrentUserAdminOrBookingOfficer(): boolean {
    return Boolean(GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer);
  }

  isCurrentUserNotIndividualClientOrOrg() {
    return Boolean(GLOBAL.currentUser instanceof Administrator || GLOBAL.currentUser instanceof BookingOfficer || GLOBAL.currentUser instanceof Interpreter);
  }

  userLogout() {
      AuthGuard.logout();
      // reload after logout so that the angular service does not persist the data
      this.router.navigate(['/authenticate/logout']).then(() =>  window.location.reload());
  }

  isAdmin() {
    return (GLOBAL.currentUser instanceof Administrator) ? '31%' : '44%';
  }

  startGetAllMessagesThreads() {
    if (localStorage.getItem('message')) {
      this.draftMessage = JSON.parse(localStorage.getItem('message'));
      this.threadPage = this.draftMessage.thread_page_no;
      this.searchInterpreterParam = this.draftMessage.interpreter_name;
    }
    this.pollingSub = this.messageService.pollingAllMessageThreads(GLOBAL.currentUser.business_id, this.threadPage, this.searchInterpreterParam)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.unreadMessageThreads = res.data.unread_message_threads_count;
          this.ngZone.run(() => {});
        }
    });
  }

  getAllMessagesThreads() {
    if (localStorage.getItem('message')) {
      this.draftMessage = JSON.parse(localStorage.getItem('message'));
      this.threadPage = this.draftMessage.thread_page_no;
      this.searchInterpreterParam = this.draftMessage.interpreter_name;
    }
    this.messageSub = this.messageService.allMessageThreads(GLOBAL.currentUser.business_id, this.threadPage, this.searchInterpreterParam)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.unreadMessageThreads = res.data.unread_message_threads_count;
        }
    },
    errors => {
        let e = errors.json();
        this.notificationServiceBus.launchNotification(true, e);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/header/header.component.ts